/** Brand assets under `public/` — keep in sync with `public/images/logo.svg` */
export const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/images/logo.svg`;

/** Documentation URL. Defaults to the in-app /docs page (Documentation.jsx)
 *  which is the actual content surface — the previous external default
 *  (docs.datanodes.nodefleet.net) doesn't resolve. Override via
 *  REACT_APP_DOCS_URL only if a real external docs site goes live. */
export const DOCS_URL =
  process.env.REACT_APP_DOCS_URL || "/#/docs";

/** Discord invite. Used by landing footer social icons. */
export const DISCORD_URL =
  process.env.REACT_APP_DISCORD_URL || "https://discord.gg/nodefleet";

/** Support channel — direct link to the DataNodes Discord support thread.
 *  Used by the dashboard Sidebar's "Support" entry. */
export const SUPPORT_URL =
  process.env.REACT_APP_SUPPORT_URL ||
  "https://discord.gg/qejbaav63m";
